import { observer } from 'mobx-react-lite'
import React from 'react'
import { Typography } from 'shared/ui'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { SmartCallActionNode } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action/ui/SmartCallActionNode/SmartCallActionNode'
import { type ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import { PlayAudioStore } from '../../store/PlayAudioStore'

export const PlayAudioNode = observer((props: ISmartCallNodeProps) => {
  const { id } = props
  const { getActionById } = useSmartCallFlowBuilderContext()
  const store = getActionById(id)
  if (!(store instanceof PlayAudioStore)) return null

  const { step } = store

  return (
    <SmartCallActionNode
      iconProps={PlayAudioStore.iconProps}
      title={PlayAudioStore.title}
      placeholder={'Choose an audio'}
      content={
        step.args?.audio_url ? (
          <Typography ariaLabel={'message'} variant={'body-md-regular'}>
            Caller hears this message
          </Typography>
        ) : null
      }
      {...props}
    />
  )
})
